var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24.004,
    height: 24,
    viewBox: "0 0 24.004 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10049",
    "data-name": "Rectangle 10049",
    width: 24.004,
    height: 24,
    fill: "#734bd1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7977",
    "data-name": "Group 7977",
    transform: "translate(-641 -394)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7976",
    "data-name": "Group 7976",
    transform: "translate(641 394)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7975",
    "data-name": "Group 7975",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_53666",
    "data-name": "Path 53666",
    d: "M22.393,292.347c.118-.008.236-.023.354-.024q3.139,0,6.278-.005,6.6,0,13.209,0c.108,0,.216.018.324.028Z",
    transform: "translate(-20.557 -268.347)",
    fill: "#734bd1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53667",
    "data-name": "Path 53667",
    d: "M292.456,135.018a2.256,2.256,0,0,1-.023-.23q0-4.193,0-8.387,0-1.491,0-2.983a1.348,1.348,0,0,1,.021-.169Z",
    transform: "translate(-268.452 -113.143)",
    fill: "#734bd1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53668",
    "data-name": "Path 53668",
    d: "M20.71,20.7v-.171q0-3.534,0-7.069c0-.391,0-.39.278-.671l2.828-2.849.145-.148c0,.1,0,.163,0,.229,0,1.365-.012,2.73-.013,4.1q0,3.728,0,7.456a2.527,2.527,0,0,1-.108.935,2.142,2.142,0,0,1-1.681,1.416,2.985,2.985,0,0,1-.56.017q-9.553,0-19.106,0a3.374,3.374,0,0,1-.861-.064,2.09,2.09,0,0,1-1.57-1.653A2.693,2.693,0,0,1,0,21.617Q0,15.718,0,9.819,0,6.085,0,2.352A2.281,2.281,0,0,1,.589.714a2.028,2.028,0,0,1,1.473-.7C3.107,0,4.152,0,5.2,0q4.234,0,8.468,0c.158,0,.316.008.489.013L11.622,2.548c-.214.214-.427.43-.648.638a.3.3,0,0,1-.189.073q-3.361,0-6.722,0c-.235,0-.47,0-.7-.006-.07,0-.1.02-.094.093.006.282.007.565.007.848q0,7.59,0,15.179c0,.415,0,.831,0,1.246,0,.068.018.086.086.086q3.3,0,6.6,0H20.71",
    transform: "translate(0 0)",
    fill: "#734bd1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53669",
    "data-name": "Path 53669",
    d: "M104.887,4.285a2.458,2.458,0,0,1-.03-.325,5.137,5.137,0,0,0-.414-1.767A2.8,2.8,0,0,0,102.924.619,6.36,6.36,0,0,0,100.8.129a.461.461,0,0,0-.416.159C100.061.633,91.686,9,88.871,11.81c-.231.231-.464.459-.71.7a12.719,12.719,0,0,1,4.367,4.33c.061-.064.111-.118.163-.17,2.093-2.091,11.784-11.78,12.085-12.077a.327.327,0,0,0,.11-.309",
    transform: "translate(-80.932 -0.116)",
    fill: "#734bd1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53670",
    "data-name": "Path 53670",
    d: "M66.479,171.568v-.109q0-2.053,0-4.106a.273.273,0,0,1,.09-.216c.128-.122.254-.247.374-.377a.1.1,0,0,1,.141-.022,9.35,9.35,0,0,1,1.641,1.026,9.09,9.09,0,0,1,2.567,3.157c.046.091.053.149-.034.223-.124.1-.228.234-.349.344a.294.294,0,0,1-.175.081q-2.094.007-4.188,0l-.065,0",
    transform: "translate(-61.026 -153.048)",
    fill: "#734bd1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.9da194ba7b2bbe2783e12e5c6d8f8731.svg";
export { ForwardRef as ReactComponent };